var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit } from '@angular/core';
import { MatSidenav } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { config } from '../../../../config/config';
import { VisitorCalendarActionCommand } from '../../../commands/pagination.query.command';
import { BaseComponent } from '../../../common/components/base.component';
import { FacebookPost } from '../../../common/components/facebook.post/facebook.post';
import { PageSpinnerComponent } from '../../../common/components/page.spinner/page.spinner.component';
import { PlaceCategory } from '../../../common/constants/constant';
import { localStorageKeys } from '../../../common/constants/local.storage.keys';
import { getRouteUrl, routeConfigs } from '../../../common/constants/route.config';
import { popupCenter } from '../../../common/extensions/browser/browser.extensions';
import { GoogleMapsService } from '../../../common/services/google.maps.service';
import { ModalService } from '../../../common/services/modal.service';
import { HubVisitorFeatureToggle } from '../../../models/hub/hub.visitor.feature.toggle';
import { ConfigService } from '../../../services/config.service';
import { ImageService } from '../../../services/image.service';
import { ShareService } from '../../../services/share.service';
import { VisitorApiService } from '../../../services/visitor.api.service';
import { AllFrontendSettingsStore, VisitorCalendarStore } from '../../../stores/visitor.calendar.store';
var VisitorPlaceDetailsComponent = /** @class */ (function (_super) {
    __extends(VisitorPlaceDetailsComponent, _super);
    function VisitorPlaceDetailsComponent(router, activatedRoute, googleMapService, visitorCalendarStore, visitorApiService, imageService, allFrontendSettingsStore, modalService) {
        var _this = _super.call(this, { activatedRoute: activatedRoute }) || this;
        _this.router = router;
        _this.activatedRoute = activatedRoute;
        _this.googleMapService = googleMapService;
        _this.visitorCalendarStore = visitorCalendarStore;
        _this.visitorApiService = visitorApiService;
        _this.imageService = imageService;
        _this.allFrontendSettingsStore = allFrontendSettingsStore;
        _this.modalService = modalService;
        _this.isSideBarOpened = true;
        _this.lat = ConfigService.config.google.USCenter.lat;
        _this.lng = ConfigService.config.google.USCenter.lng;
        _this.mapZoom = 14;
        _this.paginationIndex = 0;
        _this.paginationPageLimit = 20;
        _this.noMoreNext = false;
        _this.isLoading = false;
        _this.actionCommand = new VisitorCalendarActionCommand();
        _this.simpleMenu = true;
        _this.facebookLogo = config.facebook.logo;
        _this.featuresToggle = new HubVisitorFeatureToggle();
        _this.hideIconMapStyler = ConfigService.config.google.hideMapBusinessIconStyles;
        return _this;
    }
    VisitorPlaceDetailsComponent.prototype.ngOnInit = function () {
        var _this = this;
        var _a = this.allRouteParams, hubName = _a.hubName, menuType = _a.menuType;
        this.hubName = hubName;
        this.facebookLogo = this.imageService.imageSourceUrl(this.facebookLogo);
        this.simpleMenu = menuType === 'simple';
        this.loadPlaces();
        this.allFrontendSettingsStore.allFrontendSettingsCommand.takeUntil(this.isDestroyed)
            .subscribe(function (command) {
            if (command.toggle) {
                // this.featuresToggle.tripPlanner = command.toggle.tripPlanner;
                // this.featuresToggle.placeCalendar = command.toggle.placeCalendar;
                // this.featuresToggle.manualEvents = command.toggle.manualEvents;
                // this.featuresToggle.eventByGeolocation = command.toggle.eventByGeolocation;
                _this.featuresToggle = command.toggle;
            }
        });
    };
    Object.defineProperty(VisitorPlaceDetailsComponent.prototype, "isEventEnabled", {
        get: function () {
            return this.featuresToggle.manualEvents || this.featuresToggle.eventByGeolocation;
        },
        enumerable: true,
        configurable: true
    });
    VisitorPlaceDetailsComponent.prototype.close = function () {
        this.sideBar.close();
    };
    VisitorPlaceDetailsComponent.prototype.goBack = function () {
        var category = this.allRouteParams.category;
        category = PlaceCategory.getPlaceCategoryKey(category);
        this.router.navigateByUrl(getRouteUrl(routeConfigs.visitor.placeCalendar, {
            hubName: this.hubName,
            menuType: this.simpleMenu ? 'simple' : 'normal',
            category: category
        }), { skipLocationChange: this.noChangeUrlWhenRedirect });
    };
    VisitorPlaceDetailsComponent.prototype.gotoDetails = function (id) {
        var _a = this.allRouteParams, hubName = _a.hubName, category = _a.category;
        category = PlaceCategory.getPlaceCategoryKey(category);
        this.router.navigateByUrl(getRouteUrl(routeConfigs.visitor.placeDetails, {
            hubName: hubName,
            placeId: id,
            menuType: this.simpleMenu ? 'simple' : 'normal',
            category: category
        }), { skipLocationChange: this.noChangeUrlWhenRedirect });
        window.location.reload();
    };
    VisitorPlaceDetailsComponent.prototype.showInfoWindow = function (marker) {
        if (!marker._isOpen) {
            marker._openInfoWindow();
        }
        clearTimeout(this.timeout);
    };
    VisitorPlaceDetailsComponent.prototype.hideInfoWindow = function (marker) {
        this.timeout = setTimeout(function () {
            marker._closeInfoWindow();
        }, 1500);
    };
    VisitorPlaceDetailsComponent.prototype.getDirectionToPlaceAddress = function () {
        var url = config.eventShare.googleMapGetDirection
            .replace('${address}', encodeURIComponent(this.place.address.address));
        window.open(url, '_blank');
    };
    VisitorPlaceDetailsComponent.prototype.gotoEventCalendar = function () {
        // if (this.isMobile && isSafari()) {
        //     setTimeout(() => {
        //         this.actionCommand.isEventCalendar = true;
        //         this.visitorCalendarStore.actionCommand.next(this.actionCommand);
        //     });
        // }
        this.router.navigateByUrl(getRouteUrl(routeConfigs.visitor.eventCalendar, {
            hubName: this.hubName
        }), { skipLocationChange: this.noChangeUrlWhenRedirect });
        this.actionCommand.isEventCalendar = true;
        this.visitorCalendarStore.actionCommand.next(this.actionCommand);
    };
    VisitorPlaceDetailsComponent.prototype.gotoPlaceCalendar = function () {
        var category = this.allRouteParams.category;
        var categoryValue = category;
        var categoryPath = category;
        if (category.indexOf('-') !== -1 && category.indexOf(' ') === -1) {
            categoryValue = PlaceCategory.getPlaceCategoryValue(category);
            categoryPath = category;
        }
        else if (category.indexOf('-') === -1 && category.indexOf(' ') !== -1) {
            categoryPath = PlaceCategory.getPlaceCategoryKey(category);
            categoryValue = category;
        }
        // if (this.isMobile && isSafari()) {
        //     setTimeout(() => {
        //         this.actionCommand.isEventCalendar = false;
        //         this.actionCommand.queryCommand.category = categoryValue;
        //         this.visitorCalendarStore.actionCommand.next(this.actionCommand);
        //     });
        // }
        this.router.navigateByUrl(getRouteUrl(routeConfigs.visitor.placeCalendar, {
            hubName: this.hubName,
            category: categoryPath,
            menuType: this.simpleMenu ? 'simple' : 'normal',
        }), { skipLocationChange: this.noChangeUrlWhenRedirect });
        this.actionCommand.isEventCalendar = false;
        this.actionCommand.queryCommand.category = categoryValue;
        this.visitorCalendarStore.actionCommand.next(this.actionCommand);
    };
    VisitorPlaceDetailsComponent.prototype.showMorePlaces = function () {
        if (this.noMoreNext) {
            this.paginationIndex = -1;
            this.noMoreNext = false;
        }
        this.paginationIndex++;
        var start = this.paginationPageLimit * this.paginationIndex;
        var end = start + this.paginationPageLimit;
        if (end >= this.allPlaces.length) {
            end = this.allPlaces.length;
            this.noMoreNext = true;
        }
        this.places = this.allPlaces.slice(start, end);
        if (this.sideBar) {
            this.sideBar.close();
        }
        this.showingCount = start + 1 + " - " + end;
        this.fitBounds();
    };
    VisitorPlaceDetailsComponent.prototype.getFacebookPlaceFeed = function () {
        var id = ShareService.getFacebookPlaceId(this.place.hostLink);
        // if (id && FacebookLoginButtonComponent.isUserLoggedWithFacebook) {
        //     FB.api(config.facebook.graphApi.placePosts
        //             .replace('${accessToken}', FacebookLoginButtonComponent.userAccessToken)
        //             .replace('${placeId}', id),
        //         (response) => {
        //             this.placeFeedPaging = response.paging;
        //
        //             if (!!response.error) {
        //                 console.error(response.error);
        //                 return;
        //             }
        //
        //             this.updatePlaceFeeds(response.data);
        //         });
        // }
        var post = new FacebookPost();
        post.actions = [{ link: 'https://wwww.google.com' }, { link: 'https://facebook.com' }];
        post.from = { name: 'Aline', id: '12345678', picture: 'https://cdn2.iconfinder.com/data/icons/business-management-52/96/Artboard_20-512.png', link: 'https://facebook.com' };
        post.full_picture = 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTCyes0Hq_VFx85baJNqI3YUJsXpBjoaX3U49wpuQnRraz0imQTCg';
        post.id = '1233';
        post.message = 'This place is great. Came here for the Liverpool match and turns out the players are staying here, so that was an added bonus. The hotel itself is spotless, the room is so clean and has everything you need. The employees are very nice and accommodating';
        post.updated_time = new Date().toLocaleDateString();
        var post1 = new FacebookPost();
        post1.actions = [{ link: 'https://wwww.google.com' }, { link: 'https://facebook.com' }];
        post1.from = { name: 'Randy', id: '12345678', picture: 'https://cdn2.iconfinder.com/data/icons/internet-security-5/64/Account_Focus-512.png', link: 'https://facebook.com' };
        post1.full_picture = 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQA_DjPteRSjQ74py1tbIsJMipozp2p-y0xpKaufyfadxFAWTjYaQ';
        post1.id = '1233';
        post1.message = 'Stayed here many times while working in Charlotte. The rooms are always great, but the service has declined over time. Calling the front desk is met with the feeling like youre burdening the staff. I got a big sigh today before I even asked for anything';
        post1.updated_time = new Date().toLocaleDateString();
        this.placeFeeds = [post, post1];
        // this.updatePlaceFeeds(this.placeFeeds.concat([post]));
    };
    VisitorPlaceDetailsComponent.prototype.getNextFacebookPlaceFeed = function (event) {
        var _this = this;
        FB.api(this.placeFeedPaging.next, function (response) {
            event.complete();
            _this.placeFeedPaging = response.paging;
            if (!!response.error) {
                console.error(response.error);
                return;
            }
            _this.updatePlaceFeeds(_this.placeFeeds.concat(response.data));
        });
    };
    VisitorPlaceDetailsComponent.prototype.getDirectionToEventAddress = function () {
        var address = this.place.address.address || this.place.address;
        var url = config.eventShare.googleMapGetDirection
            .replace('${address}', encodeURIComponent(address.toString()));
        window.open(url, '_blank');
    };
    VisitorPlaceDetailsComponent.prototype.shareEventToFacebook = function () {
        var params = {
            method: 'share',
            href: window.location.href,
            quote: (this.place.title || this.place.name) + ' - ' + (this.place.description || this.place.about),
            picture: this.place.cover ? this.place.cover.source : null
        };
        FB.ui(params, function () {
        });
    };
    VisitorPlaceDetailsComponent.prototype.tweetEvent = function () {
        var shareLink = config.eventShare.tweet
            .replace('${text}', this.place.name)
            .replace('${url}', encodeURIComponent(window.location.href));
        popupCenter(shareLink);
    };
    VisitorPlaceDetailsComponent.prototype.mailEvent = function () {
        if (this.isMobile) {
            window.open(ShareService.toMailablePlace(this.place.hubName, this.place, window.location.href));
        }
        else {
            window.location.href = ShareService.toMailablePlace(this.place.hubName, this.place, window.location.href);
        }
    };
    VisitorPlaceDetailsComponent.prototype.loadPlaces = function () {
        var _this = this;
        this.isLoading = true;
        this.loadingSpinner.show();
        var placeId = this.allRouteParams.placeId;
        var allPlacesWithCurrent = JSON.parse(localStorage.getItem(localStorageKeys.visitorPlaces));
        var needToLoadPlaces = false;
        if (!allPlacesWithCurrent) {
            needToLoadPlaces = true;
        }
        else {
            this.place = allPlacesWithCurrent.first(function (x) { return x._id === placeId; });
            if (!this.place) {
                needToLoadPlaces = true;
            }
            else {
                this.setMeta();
            }
        }
        if (needToLoadPlaces) {
            this.getPlaces().subscribe(function (data) {
                _this.place = data.first(function (x) { return x._id === placeId; });
                localStorage.setItem(localStorageKeys.visitorPlaces, JSON.stringify(data.slice(0, 1000)));
                if (!_this.place) {
                    _this.modalService.showErrorModal('Place id is wrong!');
                    _this.gotoPlaceCalendar();
                    return;
                }
                _this.setMeta();
                _this.pagination(data);
            });
            return;
        }
        this.pagination(allPlacesWithCurrent);
        this.getPlaces().subscribe(function (data) {
            _this.allPlaces = data;
            localStorage.setItem(localStorageKeys.visitorPlaces, JSON.stringify(data.slice(0, 1000)));
        });
    };
    VisitorPlaceDetailsComponent.prototype.shareOverrideOGMeta = function (overrideLink, overrideTitle, overrideDescription, overrideImage) {
        FB.ui({
            method: 'share_open_graph',
            action_type: 'og.likes',
            href: '',
            action_properties: {
                'og:url': window.location.href,
            }
            // action_properties: JSON.stringify({
            //     object: {
            //         'og:url': overrideLink,
            //         'og:title': overrideTitle,
            //         'og:description': overrideDescription,
            //         'og:image': overrideImage
            //     }
            // })
        }, function (response) {
            // Action after response
        });
    };
    VisitorPlaceDetailsComponent.prototype.setMeta = function () {
        // this.shareOverrideOGMeta();
        // this.createMeta('og:description', this.place.description||this.place.about);
        // this.createMeta('og:title', this.place.name||this.place.title);
        // this.createMeta('og:url', window.location.href);
        // this.createMeta('og:image', this.place.cover?this.place.cover.source:'');
    };
    VisitorPlaceDetailsComponent.prototype.createMeta = function (name, content) {
        var metaTag = document.createElement('meta');
        metaTag.name = name;
        metaTag.content = content;
        document.getElementsByTagName('head')[0].appendChild(metaTag);
    };
    VisitorPlaceDetailsComponent.prototype.pagination = function (allPlacesWithCurrent) {
        var _this = this;
        this.getFacebookPlaceFeed();
        this.allPlaces = allPlacesWithCurrent.filter(function (x) { return x._id !== _this.place._id; });
        this.paginationIndex = 0;
        if (this.allPlaces.length > this.paginationPageLimit) {
            var max = this.paginationPageLimit * (this.paginationIndex + 1);
            this.places = this.allPlaces.slice(0, max);
            this.showingCount = this.paginationPageLimit * this.paginationIndex + 1 + " - " + max;
        }
        else {
            this.places = allPlacesWithCurrent;
        }
        if (!this.place.lat) {
            this.mapZoom = ConfigService.config.google.fullUSMapZoom;
        }
        this.fitBounds();
        this.isLoading = false;
        this.loadingSpinner.hide();
    };
    VisitorPlaceDetailsComponent.prototype.getPlaces = function () {
        return this.visitorApiService.getPlaces(this.hubName, { page: 1, limit: 0, category: 'All' });
    };
    VisitorPlaceDetailsComponent.prototype.updatePlaceFeeds = function (placeFeeds) {
        this.placeFeeds = placeFeeds;
        this.placeFeeds.forEach(function (x) {
            x.from.link =
                config.facebook.graphApi.profile.replace('${userId}', x.from.id);
            x.from.picture =
                config.facebook.graphApi.profilePictureSquare.replace('${userId}', x.from.id);
        });
    };
    VisitorPlaceDetailsComponent.prototype.fitBounds = function () {
        var _this = this;
        this.googleMapService.getGoogle().then(function () {
            _this.latLngBounds = new google.maps.LatLngBounds();
            _this.places.forEach(function (x) {
                if (x.lat && x.lng) {
                    _this.latLngBounds.extend(new google.maps.LatLng(x.lat, x.lng));
                }
            });
        });
    };
    return VisitorPlaceDetailsComponent;
}(BaseComponent));
export { VisitorPlaceDetailsComponent };



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/visitor/place.details/visitor.place.details.component.ts.pre-build-optimizer.js